import { urls } from 'core/appUrls';
import React, { FC } from 'react';
import { useHistory } from 'react-router';
import ButtonDefault from 'shared/components/Buttons/ButtonsDefault';
import styles from './RecoveryCongrats.module.scss';

type RecoveryCongratsProps = {
	title: string;
	isRecoverySuccess?: boolean;
};

const RecoveryCongrats: FC<RecoveryCongratsProps> = ({ title, isRecoverySuccess }: RecoveryCongratsProps) => {
	const history = useHistory();
	return (
		<div className={styles.content}>
			<span>{title}</span>
			{isRecoverySuccess && (
				<ButtonDefault
					title="Back to login"
					classList={['primary', 'extra_lg']}
					clickHandler={() => history.push(urls.loginSuperAdmin)}
				/>
			)}
		</div>
	);
};

export default RecoveryCongrats;
